<script setup>
import { ref, watch, computed } from 'vue';

const props = defineProps({
  label: String,
  field: String,
  currentUrl: String, // URL gambar yang sudah ada
  alt: String,
  height: {
    type: String,
    default: '200px'
  },
  helpText: String
});

const emit = defineEmits(['update:file']);

// Generate unique ID for accessibility
const inputId = computed(() => `file-upload-${props.field || Math.random().toString(36).substr(2, 9)}`);

const previewUrl = ref(props.currentUrl);
const fileInput = ref(null);
const selectedFile = ref(null);
const isUploading = ref(false);

watch(() => props.currentUrl, (newVal) => {
  previewUrl.value = newVal;
});

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    // Show preview immediately
    const reader = new FileReader();
    reader.onload = (e) => {
      previewUrl.value = e.target.result;
    };
    reader.readAsDataURL(file);

    // Store file for later upload
    selectedFile.value = file;
  }
};

const uploadFile = () => {
  if (selectedFile.value) {
    isUploading.value = true;
    // Emit file to parent to handle upload
    emit('update:file', selectedFile.value);
    
    // Reset after short delay (parent will handle actual upload)
    setTimeout(() => {
      isUploading.value = false;
      selectedFile.value = null;
    }, 1500);
  }
};
</script>

<template>
  <div class="form-group">
    <div class="mb-3 d-flex align-items-center justify-content-center overflow-hidden border rounded"
         :style="{ width: '100%', height: height, backgroundColor: '#f9f9f9' }">
        
      <img v-if="previewUrl" 
           :src="previewUrl" 
           :alt="alt || 'Preview'" 
           style="max-width: 100%; max-height: 100%; object-fit: contain;" />
           
      <span v-else class="text-muted">No Image</span>
    </div>
    
    <label class="form-label" v-if="label" :for="inputId">{{ label }}</label>
    <input 
      type="file" 
      ref="fileInput"
      :id="inputId"
      :name="field || 'file'"
      class="form-control mb-2" 
      accept="image/*"
      @change="handleFileChange"
    >
    <div class="d-flex align-items-center mt-2">
      <small v-if="helpText" class="text-muted">{{ helpText }}</small>
      <button 
        type="button" 
        class="btn btn-sm btn-primary ms-auto" 
        @click="uploadFile" 
        :disabled="!selectedFile || isUploading"
      >
        <i v-if="isUploading" class="fa fa-spinner fa-spin me-1"></i>
        <i v-else class="fa fa-upload me-1"></i>
        Upload
      </button>
    </div>
  </div>
</template>
